import { DependenciesService } from '@/apps/product-source-dialog/services/dependencies';
import ProductSourceProductSource from '../product-source';
import ProductSourceDisplaySettings from '../display-settings';
import EmptyState from '../empty-state';
import defaultTranslations from '../../translations.json';
import * as isEmpty from 'lodash.isempty';
import * as merge from 'lodash.merge';

const DEFAULT_MINIMUM = 1;
const DEFAULT_LIMIT = 10;
const DEFAULT_SELECTED_GROUP = 'product_segment';

export default {
  name: 'ProductSourceDialog',
  components: { ProductSourceProductSource, ProductSourceDisplaySettings, EmptyState },
  mounted() {
    this.$refs.productSourceSelectorDialog.addEventListener('dialog.close', () => this.$emit('close'));
  },
  data() {
    return {
      productSources: [],
      displaySettings: { minimum: DEFAULT_MINIMUM, limit: DEFAULT_LIMIT, selectedGroup: DEFAULT_SELECTED_GROUP },
      isRemoveButtonShown: true,
      headline: '',
      loading: true,
      translations: { ...defaultTranslations },
      error: false,
      initialSource: {},
      showEmptyState: false,
      flippers: [],
      isSelectedProductSourceCalculated: true
    };
  },
  methods: {
    setHeadline(headline) {
      this.headline = headline;
    },
    openDialog(initialSource) {
      initialSource = isEmpty(initialSource) ? {} : initialSource;
      this.error = false;
      this.loading = true;
      this.$refs.productSourceSelectorDialog.open();

      DependenciesService.create()
        .load()
        .then(({ productSources, translations, flippers }) => {
          this.productSources = productSources.map(p => ({
            ...p,
            display_id: `${p.type}.${p.id}`,
            ...(p.type === initialSource.type && p.id === initialSource.source_type
              ? {
                  selected: true,
                  ...(!isEmpty(initialSource.arguments) ? { arguments: initialSource.arguments } : {})
                }
              : { selected: false }),
            ...(p.display_group ? {} : { display_group: p.type }) // TODO: remove after new format if released
          }));
          this.translations = merge({}, this.translations, translations);
          this.flippers = flippers;

          if (isEmpty(this.productSources)) {
            this.showEmptyState = true;
          } else if (isEmpty(this.productSources.find(p => p.selected))) {
            this.isRemoveButtonShown = false;
            this.onSourceSelected(this.productSources[0].display_id);
          }
          this.displaySettings = {
            minimum: initialSource.minimum || DEFAULT_MINIMUM,
            limit: initialSource.limit || DEFAULT_LIMIT,
            selectedGroup: this.selectedDisplayGroup() || DEFAULT_SELECTED_GROUP
          };
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.initialSource = initialSource;
          this.error = true;
          this.loading = false;
        });
    },
    cancel() {
      this.$refs.productSourceSelectorDialog.close();
    },
    apply() {
      this.$refs.productSourceSelectorDialog.close();
      const { id: source_type, type, arguments: args } = this.productSources.find(p => p.selected) || {};
      const { minimum, limit } = this.displaySettings;
      this.$nextTick(() =>
        this.$emit('apply', JSON.parse(JSON.stringify({ source_type, type, minimum, limit, arguments: args })))
      );
    },
    remove() {
      this.$refs.productSourceSelectorDialog.close();
      this.$emit('remove');
    },
    onSourceSelected(display_id) {
      this.productSources = this.productSources.map(p => ({ ...p, selected: p.display_id === display_id }));
      this.displaySettings = { ...this.displaySettings, selectedGroup: this.selectedDisplayGroup() };

      const selectedProductSource = this.productSources.find(p => p.selected);
      if (selectedProductSource.on_demand_enabled) {
        this.isSelectedProductSourceCalculated = true;
      } else {
        this.isSelectedProductSourceCalculated = selectedProductSource.last_success_job_run_at !== null;
      }
    },
    selectedDisplayGroup() {
      const selectedSource = this.productSources.find(productSource => productSource.selected) || {};
      return selectedSource.display_group || DEFAULT_SELECTED_GROUP;
    },
    onArgumentsChanged(display_id, args) {
      this.productSources = this.productSources.map(p => (p.display_id === display_id ? { ...p, arguments: args } : p));
    },
    onDisplaySettingChanged(settings) {
      this.displaySettings = settings;
    }
  }
};
